import React, { Fragment } from 'react'
import { Container, makeStyles, Box, NoSsr } from '@material-ui/core'
import { darken } from '@material-ui/core/styles/colorManipulator'
import Layout from '../components/layout'
import { Banner } from '../components/Banner'
import { HomeFiltering } from '../components/dashboard/Filtering'
import { LatestOffers } from '../components/dashboard/LatestOffers'
import { ActiveCompanies } from '../components/dashboard/ActiveCompanies'
import { Technologies } from '../components/dashboard/Technologies'
import { News } from '../components/dashboard/News'
import { WhoAreWe } from '../components/dashboard/Whoarewe'
import { SubscribeMe } from '../components/dashboard/subscribe_me'
import { FetchedMain } from '../components/dashboard/Fetchedmain'
import { ssrFetch, mapByIds } from '../components/context/useFetch'
import { Trans } from 'react-i18next'
import { getCountryCodeFromIp } from './hire-developer'
import { LogWithQueryParam } from './set-password'
import { Kpis } from '../components/dashboard/kpis'
import PackConsumption from '../components/pack_consumption'
import { Interviews } from '../components/dashboard/interviews'
import { AccueilEntreprise } from '../components/dashboard/accueil-entreprise'
import { AccueilGlobal } from '../components/dashboard/accueil-global'
import { Trends } from '../components/header'
import allPagesProps from '../components/common/all_pages_props'

export const useStyles = makeStyles((theme) => ({
  chip: {
    fontSize: '19px',
    padding: '16px'
  },
  paper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  meme1: {
    height: '200px',
    marginLeft: '20px',
    borderRadius: '5px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      float: 'center',
      width: '100%',
      height: '30%'
    }
  },
  meme2: {
    height: '200px',
    float: 'left',
    marginRight: '20px',
    borderRadius: '5px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      float: 'center',
      width: '100%',
      height: '30%'
    }
  },
  title: {
    flexGrow: 1,
    cursor: 'pointer'
  },
  icon: {
    alignSelf: 'center',
    padding: 0
  },
  card: {
    display: 'grid',
    gridTemplateRows: '1fr auto',
    height: '100%',
    transition: '0.3s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: darken(theme.palette.primary.main, 0.4),
      color: 'white',
      '& .ge--MuiTypography-root, a, & .ge--MuiChip-outlined': {
        color: 'white !important'
      }
    }
  },
  cardContent: {
    display: 'grid',
    gap: theme.spacing('2'),
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr auto',
    },
    '& .row-1': {
      display: 'grid',
      [theme.breakpoints.up('md')]: {
        gridTemplateColumns: '64px 1fr'
      },
      gap: theme.spacing('1'),
      '& .logo': {
        width: '64px',
        height: 'auto',
        backgroundSize: 'contain'
      },
      '& .noLink': {
        color: theme.palette.text.primary,
        textDecoration: 'none'
      },
    },
    '& .row-2': {
      display: 'grid',
      gridAutoRows: 'min-content',
      gap: theme.spacing('0.5'),
      '& > *': {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
          justifyContent: 'end'
        },
        gap: theme.spacing('1'),
        color: theme.palette.text.secondary,
        '& span': {
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing('0.5'),
          '& .ge--MuiSvgIcon-root': {
            fontSize: 'inherit'
          }
        },
        '& .ge--MuiDivider-vertical': {
          width: '2px',
          height: '12px',
          margin: 'auto 0',
          '&:first-child': {
            display: 'none'
          }
        }
      }
    }
  },
  root: {
    width: '100%',
    borderRadius: theme.spacing(2),
    transition: '0.3s',
    padding: 5,
    boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: darken(theme.palette.primary.main, 0.3),
      color: 'white',
      '& .ge--MuiTypography-root, a': {
        color: '#fff !important'
      }
    }
  },
  cardActions: {
    justifyContent: 'space-between',
    gap: theme.spacing('1'),
    padding: theme.spacing('2'),
    "& .techno": {
      display: 'flex',
      gap: theme.spacing('0.5')
    }
  },
  divider: {
    '.postItem:last-child &': {
      display: 'none'
    }
  },
  logo: {
    width: 100,
    height: 'auto',
    backgroundSize: 'contain',
    margin: '10px'
  },
  date: {
    position: 'relative',
    marginLeft: '1050px',
    bottom: '20px'
  },
  postLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('xs')]: {
      width: '79.6vw'
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '32vw'
    },
    [theme.breakpoints.up('lg')]: {
      width: '460px'
    }
  },
  noLink: {
    color: `${theme.palette.text.primary} !important`,
    textDecoration: 'none'
  },
  grid: {
    [theme.breakpoints.up('md')]: {
      marginLeft: 90
    }
  },
  filterBox: {
    paddingBottom: '12px'
  },
  emptySlate: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      height: '50%'
    }
  }
}))

export const OFFER_LIMIT = 6


export async function getServerSideProps(context) {
  const referer = context.req?.headers?.host

  return {
    props: {
      offers: await ssrFetch('job_offers', { referer, queryParams: { include: 'technologies,job,parent_job,company,contract_type,level' } }),
      contractTypes: await ssrFetch('contract_types', { referer }),
      jobs: await ssrFetch('jobs', { referer }).then((res) => mapByIds(res)),
      levels: await ssrFetch('levels', { referer }),
      filters: {},
      conf: await ssrFetch('conf', { referer }),
      articles: await ssrFetch('blog/articles', { referer, queryParams: { limit: 5 } }).then((articles) => mapByIds(articles)),
      openArticle: null,
      docTypes: await ssrFetch('/document_types', { referer }),
      ...(await allPagesProps(context))
    }
  }
}

const TrustmeContent = (initialData) => {
  return (
    <Fragment>
      <NoSsr>
        <Trends />
      </NoSsr>
      <Banner countryCode={initialData.isLocal} />
      <LogWithQueryParam />
      <Container>
        <PackConsumption />
      </Container>
      <Kpis />
      <Interviews />
      <Box pb={7}>
        <Container>
          <LatestOffers />
          <Box mb={5} mt={8}>
            <HomeFiltering />
          </Box>
          <FetchedMain initialData={initialData} source="homepage" />
        </Container>
        <ActiveCompanies />
        <Technologies />
        <WhoAreWe />
        <News />
        <div id="subscribe-me">
          <SubscribeMe condition={(auth) => auth.loggedIn()} h1={<Trans i18nKey="subscribe_me.title" />} subText={<Trans i18nKey="subscribe_me.subtext" />} />
        </div>
      </Box>
    </Fragment>
  )
}

const contents = {
  trustme: TrustmeContent,
  company: AccueilEntreprise,
  global: AccueilGlobal
}

const Content = ({ initialData }) => {
  let type = initialData.site?.slug || initialData.site.entity_type.toLowerCase()

  if (!Object.keys(contents).includes(type)) {
    type = 'global'
  }

  const DynamicComponent = contents[type]

  return (
    <Fragment>
      <DynamicComponent {...initialData} />
    </Fragment>
  )
}

export default function Main(initialData) {
  return (
    <Layout pageTitle="pages_titles.home" initialData={initialData}>
      <Content initialData={initialData} />
    </Layout>
  )
}
